export default __webpack_public_path__ + "static/LSDAO-f43e9d20a436f0cc30a269ee4531395c.mp3";